module.exports = __webpack_public_path__ + "media/images/review/ico-rreview-edit-s-26dddd3c2a316afbcceac25d1ce54025.svg";